module.exports = __webpack_public_path__ + "img/int-vacancy-list.810842ff.svg";